
const UserUtils = {
    updateUsers: async (changedUsers, tenID, token) => {
        let addedParams = `tenid=${tenID}`;
        
        try {
            let resp = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/bulk?${addedParams}`, {
                headers: {
                    "Authorization": "Bearer " + token.accessToken ? token.accessToken : token,
                    "Content-Type": "application/json"
                },
                method: 'POST',
                body: JSON.stringify({ commands: changedUsers })
            });

            return { status: 'success', data: resp };
        } catch (error) {
            console.log(error);
            return { status: 'error', data: error };
        }
    },

    deleteUsers: async (usersToDelete, tenID, token) => {
        let addedParams = `tenid=${tenID}`;
        let report = [];
        
        for(let user in usersToDelete) {
            let gotID = user.id ? user.id : user.user_id ? user.user_id : user;

            try {
                let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${gotID}?${addedParams}`, {
                    headers: {
                        "Authorization": "Bearer " + token.accessToken ? token.accessToken : token
                    },
                    method: 'DELETE',
                })
                
                report.push({ status: 'success', data: { userID: gotID, response: response }});
            } catch (error) {
                console.log(error);
                report.push({ status: 'fail', data: { userID: gotID, response: error }});
            }
        }

        return report;
    },

    requestWorkspaceForUsers: async (usersToRequestFor, wkspcID, tenID, token) => {
        let addedParams = `tenid=${tenID}`;
        let report = [];

        for(let user in usersToRequestFor) {
            let gotID = user.id ? user.id : user.user_id ? user.user_id : user;

            try {
                let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${gotID}/workspace-add?${addedParams}`, {
                    headers: {
                    "Authorization": "Bearer " + token.accessToken,
                    "Content-Type": "application/json"
                    },
                    method: 'POST',
                    body: JSON.stringify({ workspaceID: wkspcID, appsList: "" })
                });
                
                report.push({ status: 'success', data: { userID: gotID, response: response }});

            } catch (error) {
                console.log(error);
                report.push({ status: 'fail', data: { userID: gotID, response: error }});
            }
        }

        return report;
    },

    suAddToWorkspaceForUsers: async (usersToRequestFor, wkspcID, tenID, token) => {
        let addedParams = `tenid=${tenID}`;
        let report = [];

        for(let thisUser=0; thisUser < usersToRequestFor.length; thisUser++) {
            let gotID = usersToRequestFor[thisUser].user_id;

            try {
                let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${gotID}/workspace-add?${addedParams}`, {
                    headers: {
                    "Authorization": "Bearer " + token.accessToken,
                    "Content-Type": "application/json"
                    },
                    method: 'POST',
                    body: JSON.stringify({ workspaceID: wkspcID, appsList: "" })
                });
                
                report.push({ status: 'success', data: { userID: gotID, response: response }});

            } catch (error) {
                console.log(error);
                report.push({ status: 'fail', data: { userID: gotID, response: error }});
            }
        }

        return report;
    },

    getWkspcAndAppFromRec: (recStr) => {
        //receives a string with 'accessed workspace: [wkspc] app: [app_type]'
        //returns an array: [wkspc, app_type] or null if no matches
        let items = recStr.match(/(?<=\[).+?(?=\])/g);

        return items;
    }
}

export default UserUtils